import React, { FC, useCallback } from 'react';
import injectSheet from 'react-jss';
import Dropdown from 'Components/Dropdown';
import { FilterSlider } from 'Components/FilterSlider';
import withErrorBoundary from 'HOC/ErrorBoundary';
import styleSheet from './styles';
import { Range } from '../../classes/filter.classes';

interface Props {
  classes: any;
  callback?: (event: any, identifier: any) => void;
  totalTimeSpent?: any;
}

const options = [
  { label: 'Any', value: 'Any' },
  { label: 'VT', value: 'VT' },
  { label: 'IWC', value: 'IWC' },
  { label: 'VT or IWC', value: 'VT or IWC' },
  { label: 'VT and IWC', value: 'VT and IWC' },
];

const TotalTimeSpentMyVtIwc: FC<Props> = (props: Props) => {
  const { classes, callback, totalTimeSpent } = props;

  const onDropdownChange = (event: any) => {
    // Determine which option was selected
    callback(event, 'selection');
  };
  const vtRangeSliderChange = (values: number[]) => {
    const value = new Range(values[0], values[1]);
    callback({ target: { value } }, 'vt');
  };
  const icwRangeSliderChange = (values: number[]) => {
    const value = new Range(values[0], values[1]);
    callback({ target: { value } }, 'iwc');
  };
  const colorOverRide = {
    open: {
      border: {
        color: '#B4E1EC',
      },
      text: {
        color: '#079DC0',
      },
    },
    close: {
      border: {
        color: '#B4E1EC',
      },
      text: {
        color: '#079DC0',
      },
    },
  };
  return (
    <>
      <Dropdown
        ariaLabel="Select VT and/or IWC"
        colorOverRide={colorOverRide}
        items={options}
        width="103px"
        defaultValue={
          options[
            options.findIndex(
              (option) => option.value === totalTimeSpent.selection
            )
          ]
        }
        onChange={useCallback(onDropdownChange, [totalTimeSpent])}
      />
      <div
        className={`
          ${
            totalTimeSpent.selection !== 'VT' &&
            totalTimeSpent.selection !== 'VT or IWC' &&
            totalTimeSpent.selection !== 'VT and IWC'
              ? classes.hidden
              : classes.indented
          }`}
      >
        <div className={classes.rangeName}>VT</div>
        <FilterSlider
          color="#079DC0"
          defaultValues={{
            handleOne: totalTimeSpent.value.vt.lower,
            handleTwo: totalTimeSpent.value.vt.upper,
          }}
          upperBoundMaxLabel=" + mins"
          range={{ lowerBound: 1, upperBound: 15 }}
          step={1}
          onSlideEnd={useCallback(vtRangeSliderChange, [totalTimeSpent])}
          upperBoundDragLabel=" mins"
          lowerBoundDragLabel=" min"
          ariaLabel="Select VT Range"
        />
      </div>
      <div
        className={`
        ${
          totalTimeSpent.selection !== 'IWC' &&
          totalTimeSpent.selection !== 'VT or IWC' &&
          totalTimeSpent.selection !== 'VT and IWC'
            ? classes.hidden
            : classes.indented
        }`}
      >
        <div className={classes.rangeName}>IWC</div>
        <FilterSlider
          color="#079DC0"
          defaultValues={{
            handleOne: totalTimeSpent.value.iwc.lower,
            handleTwo: totalTimeSpent.value.iwc.upper,
          }}
          upperBoundMaxLabel=" + mins"
          range={{ lowerBound: 1, upperBound: 15 }}
          step={1}
          onSlideEnd={useCallback(icwRangeSliderChange, [totalTimeSpent])}
          upperBoundDragLabel=" mins"
          lowerBoundDragLabel=" min"
          ariaLabel="Select IWC Range"
        />
      </div>
    </>
  );
};

TotalTimeSpentMyVtIwc.defaultProps = {
  callback: () => {},
  totalTimeSpent: undefined,
};

export default withErrorBoundary(
  injectSheet(styleSheet)(TotalTimeSpentMyVtIwc)
);
